// Global cleanup function
function cleanupOrphanedMagnifiedImages() {
  // Remove any magnified images that might be stuck
  const existingMagnified = document.querySelectorAll(
    '[data-magnified-image="true"]'
  );
  existingMagnified.forEach((img) => {
    if (img.parentNode) {
      img.parentNode.removeChild(img);
    }
  });
}

export function standardizeAndMagnifyEffectHtmlImages(data, type, row) {
  if (!data) return null;

  // Clean up any orphaned magnified images first
  cleanupOrphanedMagnifiedImages();

  // Create a temporary container to parse the HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = data;

  // Find all img elements
  const images = tempDiv.querySelectorAll("img");

  if (images.length === 0) {
    return data;
  }

  // Process each image
  images.forEach((img, index) => {
    img.style.height = "50px";
    img.style.width = "auto";
    img.style.cursor = "pointer";

    const uniqueId = `magnify-img-${Date.now()}-${index}`;
    img.id = uniqueId;

    // Add mouseenter handler
    img.setAttribute(
      "onmouseenter",
      `
      (function(e) {
        const img = e.target;
        if (img._magnifiedImg) return;
        
        const magnifiedImg = document.createElement('img');
        magnifiedImg.src = img.src;
        magnifiedImg.alt = img.alt || '';
        magnifiedImg.setAttribute('data-magnified-image', 'true'); // Mark for cleanup
        magnifiedImg.style.cssText = 'position: fixed; height: 300px; width: auto; z-index: 10000; border: 2px solid #333; border-radius: 4px; box-shadow: 0 4px 8px rgba(0,0,0,0.3); background: white; padding: 2px; pointer-events: none; left: ' + (e.clientX + 10) + 'px; top: ' + (e.clientY + 10) + 'px;';
        document.body.appendChild(magnifiedImg);
        img._magnifiedImg = magnifiedImg;
      })(event)
    `
    );

    // Add mousemove handler
    img.setAttribute(
      "onmousemove",
      `
      (function(e) {
        const img = e.target;
        if (img._magnifiedImg) {
          img._magnifiedImg.style.left = (e.clientX + 10) + 'px';
          img._magnifiedImg.style.top = (e.clientY + 10) + 'px';
        }
      })(event)
    `
    );

    // Add mouseleave handler
    img.setAttribute(
      "onmouseleave",
      `
      (function(e) {
        const img = e.target;
        if (img._magnifiedImg && img._magnifiedImg.parentNode) {
          img._magnifiedImg.parentNode.removeChild(img._magnifiedImg);
          delete img._magnifiedImg;
        }
      })(event)
    `
    );
  });

  return tempDiv.innerHTML;
}
